export default {
  "content": "<path fill=\"#444\" d=\"M23.4 10.2c.3 0 .6.3.6.6V12c0 .337-.3.6-.6.6H21V15c0 .337-.3.6-.6.6h-1.2a.592.592 0 01-.6-.6v-2.4h-2.4a.592.592 0 01-.6-.6v-1.2c0-.3.263-.6.6-.6h2.4V7.8c0-.3.262-.6.6-.6h1.2c.3 0 .6.3.6.6v2.4h2.4zM8.4 12a4.785 4.785 0 01-4.8-4.8c0-2.625 2.137-4.8 4.8-4.8 2.625 0 4.8 2.175 4.8 4.8 0 2.662-2.175 4.8-4.8 4.8zm3.338 1.2c2.774 0 5.062 2.287 5.062 5.062V19.8a1.8 1.8 0 01-1.8 1.8H1.8c-1.012 0-1.8-.788-1.8-1.8v-1.538C0 15.487 2.25 13.2 5.025 13.2h.637c.825.412 1.763.6 2.738.6.975 0 1.875-.188 2.7-.6h.638z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};